'use client'

import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react'
import { usePathname, useRouter } from 'next/navigation'
import React, { useState, useEffect } from 'react'
import { GridSection } from './fragments/grid-section'
import { Routes } from '@/constants/routes'
import { Tabs } from '../ui/vercel-tabs'
import { MediaQueries } from '@/constants/media-queries'
import { useMediaQuery } from '@/hooks/use-media-query'
import { MessageDescriptor } from '@lingui/core'

interface Tab {
  id: string
  label: MessageDescriptor
  href: string
}

interface TabsAboutProps {
  badge?: string
  heading?: string
  description?: string
  tabs?: Tab[]
}

const TabsAbout = ({
  tabs = [
    {
      id: 'overview',
      label: msg`Overview`,
      href: Routes.Overview
    },
    // {
    //   id: 'team',
    //   label: msg`Team`,
    //   href: Routes.Team
    // },
    {
      id: 'org-ops',
      label: msg`Organization & Operation`,
      href: Routes.OrgOps
    },
    {
      id: 'our-journey',
      label: msg`Our Journey`,
      href: Routes.OurJourney
    },
    {
      id: 'why-choose',
      label: msg`Why Choose Pione Group`,
      href: Routes.WhyChoose
    },
    {
      id: 'awards',
      label: msg`Awards`,
      href: Routes.Awards
    }
  ]
}: TabsAboutProps) => {
  const { i18n } = useLingui()
  const pathname = usePathname()
  const router = useRouter()
  const isMobile = useMediaQuery(MediaQueries.SmDown, { ssr: true, fallback: true })

  const [activeTab, setActiveTab] = useState<string>()

  // Hàm xử lý sự kiện thay đổi tab
  const handleTabChange = (tabId: string) => {
    const selectedTab = tabs.find((tab) => tab.id === tabId)
    if (selectedTab) {
      router.push(selectedTab.href)
    }
  }

  useEffect(() => {
    const matchedTab = tabs.find((tab) => pathname.includes(tab.href))
    setActiveTab(matchedTab?.id || tabs[0].id)
  }, [pathname, tabs])

  return (
    <GridSection hideVerticalGridLines={isMobile}>
      <Tabs
        tabs={tabs.map((tab) => ({
          id: tab.id,
          label: i18n._(tab.label)
        }))}
        activeTab={activeTab}
        onTabChange={handleTabChange}
        className='py-3 w-full mx-auto flex items-center md:justify-center overflow-x-scroll scrollbar-none'
      />
    </GridSection>
  )
}

export { TabsAbout }
